import { useI18n } from "@/i18n/I18nProvider";
import Reveal, { stagger, fadeUp } from "@/components/motion/Reveal";

export default function Process() {
  const { t } = useI18n();
  const p = t.process;
  return (
    <section id="process" data-testid="process-section" className="section-pad bg-white relative">
      <div className="absolute inset-0 noise-overlay pointer-events-none" aria-hidden />
      <div className="container-pro relative">
        <div className="grid md:grid-cols-12 gap-10 items-end mb-14">
          <Reveal className="md:col-span-7">
            <div className="overline">{p.kicker}</div>
            <h2 className="mt-3 font-heading text-3xl sm:text-4xl md:text-5xl font-medium tracking-tight">
              {p.title1}
              <span className="text-ink-muted">{p.title2}</span>
            </h2>
          </Reveal>
          <Reveal variants={fadeUp} className="md:col-span-5">
            <p className="text-ink-secondary">{p.subtitle}</p>
          </Reveal>
        </div>

        <Reveal variants={stagger(0.08, 0.12)} className="grid grid-cols-1 md:grid-cols-4 gap-px bg-line border border-line rounded-lg overflow-hidden">
          {p.steps.map((s) => (
            <Reveal key={s.num} variants={fadeUp} data-testid="process-step" className="relative bg-white p-8 group overflow-hidden transition-colors hover:bg-surface-muted">
              <div
                className="absolute -top-6 -end-2 font-heading text-[120px] font-bold leading-none text-outline select-none group-hover:-translate-y-1 transition-transform duration-500"
                aria-hidden
              >
                {s.num}
              </div>
              <div className="relative">
                <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-brand-red">{p.stepLabel} {s.num}</div>
                <h3 className="mt-4 font-heading text-xl font-semibold">{s.title}</h3>
                <p className="mt-3 text-sm text-ink-secondary leading-relaxed">{s.body}</p>
              </div>
              <div className="absolute bottom-0 start-0 h-[2px] w-0 bg-brand-red transition-all duration-500 group-hover:w-full" aria-hidden />
            </Reveal>
          ))}
        </Reveal>
      </div>
    </section>
  );
}
